// src/components/FinanceRoute.js
// Updated: Tuesday, August 4, 2026 at 8:25 PM EDT

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import {
  canApproveFinancialData,
  canEnterFinancialData,
  hasFinanceAccess,
} from '../utils/financePermissions';

const FinanceRoute = ({ children, requiredLevel = 'viewer' }) => {
  const { userProfile, isInitialized } = useAuth();
  const location = useLocation();

  if (!isInitialized) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>;
  }

  const allowed = requiredLevel === 'admin'
    ? canApproveFinancialData(userProfile)
    : requiredLevel === 'counter'
      ? canEnterFinancialData(userProfile)
      : hasFinanceAccess(userProfile);

  if (!allowed) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default FinanceRoute;
